import React, {useState, useEffect} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function CodeInput(props) {
    const [inputs, setInputs] = useState({
        temperatureCodeInput: "",
        timeCodeInput: "",
        barCodeInput: ""
    })
    const [correctFormula] = useState(puzzleAnswerData[4].correctFormula)
    const [count, setCount] = useState(-1)
    const [, setFlash] = useState("")
    const [colorChange] = useState([
        "indianRed", 
        "darkgray",
        "indianRed",
        "darkgray",
        "indianRed",
        "darkgray",
        "indianRed",
        "darkgray"
    ])
    
    const boxData = [
        {
            id: 0,
            name: "temperatureCodeInput",
            size: "4",
            value: inputs.temperatureCodeInput
        },
        {
            id: 1,
            name: "timeCodeInput",
            size: "2",
            value: inputs.timeCodeInput
        },
        {
            id: 2,
            name: "barCodeInput",
            size: "6",
            value: inputs.barCodeInput
        }
    ]
    
    function handleChange(event) {
        const {name, value} = event.target
        setInputs({
            ...inputs,
            [name]: value
        })
    }
    
    useEffect(() => {
        if (count === 0) { 
            setFlash(() => setInterval(() => increaseFlashCount(), 250)) 
        } else if (count < colorChange.length) {
            document.getElementById("codeInputWrapper").style.backgroundColor = colorChange[count]
        } else {
            document.getElementById("codeInputWrapper").style.backgroundColor = "darkgray"
            setInputs({
                temperatureCodeInput: "",
                timeCodeInput: "",
                barCodeInput: ""
            })
            setFlash(prevFlash => clearInterval(prevFlash))
        }
    }, [count, colorChange])
    
    function increaseFlashCount() {
        setCount(prevCount => prevCount + 1)
    }   

    function submitFormula() {
        let attempt = inputs.temperatureCodeInput + inputs.timeCodeInput + inputs.barCodeInput
        attempt = attempt.toLowerCase()
        if (attempt === correctFormula) {
            props.callBack()
        }  else {
            setCount(0)
        }
    }
    
    const inputBoxes = boxData.map(box => {
        return (
            <input key={box.id} className="analysisInput" type="text" id={box.name} name={box.name} autoComplete="off" maxLength={box.size} size={box.size} value={box.value} onChange={handleChange}/>
        )
    })
    
    return (
        <div id="codeInputWrapper">
            {inputBoxes}
            <button className="standardButton" onClick={submitFormula}>Submit</button>
        </div>
    )
}

export default CodeInput